import { useState, type ReactNode } from 'react';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import styles from './CollapsibleCard.module.css';

export interface CollapsibleCardProps {
	title: string;
	children: ReactNode;
	headerExtra?: ReactNode;
	defaultOpen?: boolean;
}

export const CollapsibleCard = ({
	title,
	children,
	headerExtra,
	defaultOpen = false,
}: CollapsibleCardProps) => {
	const [isOpen, setIsOpen] = useState(defaultOpen);

	const toggleOpen = () => setIsOpen((open) => !open);

	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<button
					type="button"
					className={styles.titleButton}
					onClick={toggleOpen}
					aria-expanded={isOpen}
				>
					<span className={styles.title}>{title}</span>
				</button>
				{headerExtra && <div className={styles.extra}>{headerExtra}</div>}
				<button
					type="button"
					className={styles.arrowButton}
					onClick={toggleOpen}
					aria-label={isOpen ? `Recolher ${title}` : `Expandir ${title}`}
				>
					<KeyboardArrowDown className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`} />
				</button>
			</div>
			<div className={`${styles.body} ${isOpen ? styles.bodyOpen : ''}`}>
				<div className={styles.bodyInner}>{children}</div>
			</div>
		</div>
	);
};
